/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Onboarding_Connect_SubtitleInputs */

const en_ui_onboarding_connect_subtitle = /** @type {(inputs: Ui_Onboarding_Connect_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste your API key — new sessions then sync in automatically.`)
};

const de_ui_onboarding_connect_subtitle = /** @type {(inputs: Ui_Onboarding_Connect_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füge deinen API-Key ein – neue Einheiten kommen dann automatisch dazu.`)
};

/**
* | output |
* | --- |
* | "Paste your API key — new sessions then sync in automatically." |
*
* @param {Ui_Onboarding_Connect_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_onboarding_connect_subtitle = /** @type {((inputs?: Ui_Onboarding_Connect_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Onboarding_Connect_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_onboarding_connect_subtitle(inputs)
	return de_ui_onboarding_connect_subtitle(inputs)
});